<template>
  <article class="rounded-xl border border-gray-200 bg-white p-5 text-left shadow-sm">
    <header class="flex items-center justify-between gap-2">
      <div class="flex items-center gap-2">
        <span
          class="inline-flex w-fit items-center rounded-md bg-primary5 px-2 py-0.5 text-sm font-bold text-primary"
        >
          v{{ entry.version }}
        </span>
        <a
          v-if="entry.range"
          :href="compareUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="text-[10px] text-gray-400 transition hover:text-gray-600 hover:underline"
          title="Ver mudanças no GitHub"
        >
          ({{ entry.range }})
        </a>
      </div>
      <time
        :datetime="entry.date"
        class="text-xs font-medium uppercase tracking-wide text-gray-400"
      >
        {{ formattedDate }}
      </time>
    </header>

    <p v-if="entry.summary" class="mt-2 text-sm text-gray-600">{{ entry.summary }}</p>

    <ul class="mt-4 flex flex-col gap-4">
      <li v-for="(item, index) in entry.items" :key="index" class="flex gap-3">
        <span
          class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full"
          :class="ITEM_STYLES[item.type].wrap"
        >
          <svg
            class="h-4 w-4"
            :class="ITEM_STYLES[item.type].icon"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path :d="CHANGELOG_ITEM_META[item.type].icon" />
          </svg>
        </span>

        <div class="flex flex-col gap-0.5 pt-0.5">
          <span
            class="text-[11px] font-semibold uppercase tracking-wide"
            :class="ITEM_STYLES[item.type].label"
          >
            {{ CHANGELOG_ITEM_META[item.type].label }}
          </span>
          <span class="text-sm font-semibold leading-snug text-textPrimary">{{ item.title }}</span>
          <span v-if="item.description" class="text-sm leading-relaxed text-gray-600">
            {{ item.description }}
          </span>
        </div>
      </li>
    </ul>
  </article>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

import { CHANGELOG_ITEM_META } from '@/config/changelog'
import type { ChangelogEntry, ChangelogItemType } from '@/config/changelog'
import { parseLocalDate } from '@/utils/date'

const props = defineProps<{ entry: ChangelogEntry }>()

// Classes por categoria (Tailwind estatico — nao pode ser interpolado dinamicamente).
const ITEM_STYLES: Record<ChangelogItemType, { wrap: string; icon: string; label: string }> = {
  feature: { wrap: 'bg-green-50', icon: 'text-sucess', label: 'text-sucess' },
  improvement: { wrap: 'bg-primary5', icon: 'text-primary', label: 'text-primary' },
  fix: { wrap: 'bg-orange-50', icon: 'text-alert', label: 'text-alert' }
}

const formattedDate = computed(() => {
  const date = parseLocalDate(props.entry.date)
  if (!date) return props.entry.date
  return format(date, "dd 'de' MMM. 'de' yyyy", { locale: ptBR })
})

const compareUrl = computed(() => {
  if (!props.entry.range) return ''
  return `https://github.com/bng-health/minhaescala_web/compare/${props.entry.range}`
})
</script>
